export default __webpack_public_path__ + "media/images/vibrant-green-arrow-down.svg";